import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { CuratedTeacher, Mappable } from "models";
import { db } from "services";
import { dbCollections } from "utilities";

/**
 * Retrieves all curated alumni from the database.
 * @returns A Promise containing the retrieved documents as CuratedAlum objects.
 */
export async function getStudentTeachersAndHiredPlacements(): Promise<CuratedTeacher[]> {
  const memberQuery = query(
    collection(db, dbCollections.memberInfo),
    where("type", "in", ["student-teacher"])
  );
  const snapshot = await getDocs(memberQuery);
  return snapshot.docs.map(doc => {
    return { ...doc.data(), id: doc.id } as CuratedTeacher;
  });
}

export async function getStudentTeachersAndFaculty(): Promise<CuratedTeacher[]> {
  const memberQuery = query(
    collection(db, dbCollections.memberInfo),
    where("type", "in", ["student-teacher", "faculty"])
  );
  const snapshot = await getDocs(memberQuery);
  return snapshot.docs.map(doc => {
    return { ...doc.data(), id: doc.id } as CuratedTeacher;
  });
}

export async function getSpecificMember(id: string): Promise<CuratedTeacher | undefined> {
  const docRef = doc(db, dbCollections.memberInfo, id);
  const snapshot = await getDoc(docRef);
  return snapshot.exists() ? ({ ...snapshot.data(), id: snapshot.id } as CuratedTeacher) : undefined;
}

export async function getAllInfo(): Promise<Mappable[]> {
  const collectionRef = collection(db, dbCollections.memberInfo);
  const snapshot = await getDocs(collectionRef);
  return snapshot.docs.map(doc => {
    return { ...doc.data(), id: doc.id } as Mappable;
  });
}
